import { Col } from 'antd';

const CFCol = (props) => {
  return <Col {...props} />;
};

export default CFCol;